import { AccessoryResponse } from '@sales/models/accessory.model';
import { AccessoryFiltersResponse } from '../models/accessory-filters.model';

export class ApiAccessorySearchAction {
  static readonly type = '[API Accessory] Search';
}

export class ApiAccessorySearchSuccessAction {
  static readonly type = '[API Accessory] Search success';
  constructor(public accessoryResponse: AccessoryResponse) {}
}

export class ApiAccessorySearchErrorAction {
  static readonly type = '[API Accessory] Search error';
}

export namespace ApiAccessoryFilterActions {
  export class FetchAll {
    static readonly type = '[API Accessory] Get accessory filters';
  }

  export class FetchAllSuccess {
    static readonly type = '[API Accessory] Fetch All Success';
    constructor(public accessoryFilters: AccessoryFiltersResponse) {}
  }

  export class FetchAllError {
    static readonly type = '[API Accessory] Fetch All Error';
  }
}
